const invalidValues = [null, undefined, ''];

/**
 * True if the given value is defined, otherwise false.
 * Falsy values are null, undefined, ''.
 * @param value
 */
const isDefined = (value: any): boolean => !invalidValues.includes(value);

/**
 * True if the given value is an empty Array or is not an Array.
 * False if the given value is an existing filled Array.
 * @param value
 */
export const isArrayEmpty = (value: null | undefined | Array<any>): boolean =>
  !Array.isArray(value) || value.length === 0;

export default isDefined;
